import { createFileRoute } from "@tanstack/react-router";

import ChallengeEntries from "@/components/ChallengeEntries/ChallengeEntries";

const Component = () => {
  const challengeUuid = Route.useParams().challengeUuid;
  return <ChallengeEntries challengeUuid={challengeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/entries")({
  component: Component,
});
